// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { goodPathOrSiteName } from 'helpers/regex'

import {
  INVALID_NAME_VALUE,
  REQUIRED,
} from 'errors'

// validate site name
export const validateSiteName = (value, error, notRequired) => {
  // if the value's not required and the value's an empty string,
  // don't run any validation checks
  if (notRequired && !value) {
    return
  }

  if (!value) {
    error.siteName = REQUIRED
  } else if (value.length > 20) {
    error.siteName = 'Site Name cannot be longer than 20 characters.'
  } else if (!goodPathOrSiteName.test(value)) {
    error.siteName = INVALID_NAME_VALUE
  }
}
